/**
 * Runtime configuration module.
 *
 * Reads environment variables injected at container startup via window.__RUNTIME_CONFIG__
 * instead of build-time Vite env variables. This allows a single Docker image to be
 * deployed across all environments (dev, qa, stg, prod, etc.) by setting App Service
 * environment variables.
 *
 * During local development with Vite dev server, falls back to import.meta.env values.
 */

export interface RuntimeConfig {
  VITE_ASCEND_1_1_URL: string
  VITE_ASCEND_CHAT_URL: string
  VITE_CLIENT_ID: string
  VITE_TENANT_ID: string
  VITE_KDD_API: string
  VITE_PREPROCESSING_FUNC_API: string
  VITE_USER_GUIDE_URL: string
  VITE_DOWNLOAD_PLUGIN_URL: string
  VITE_ENV: string
  VITE_APPINSIGHTS_INSTRUMENTATION_KEY: string
  VITE_COOKIE_CONSENT_DATA_ATTRIBUTE: string
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig
  }
}

function getConfig(): RuntimeConfig {
  // In production (served from Node/Express), config.js sets window.__RUNTIME_CONFIG__
  if (window.__RUNTIME_CONFIG__) {
    return window.__RUNTIME_CONFIG__
  }

  // Fallback for local Vite dev server — reads from .env files as before
  return {
    VITE_ASCEND_1_1_URL: import.meta.env.VITE_ASCEND_1_1_URL || '',
    VITE_ASCEND_CHAT_URL: import.meta.env.VITE_ASCEND_CHAT_URL || '',
    VITE_CLIENT_ID: import.meta.env.VITE_CLIENT_ID || '',
    VITE_TENANT_ID: import.meta.env.VITE_TENANT_ID || '',
    VITE_KDD_API: import.meta.env.VITE_KDD_API || '',
    VITE_PREPROCESSING_FUNC_API: import.meta.env.VITE_PREPROCESSING_FUNC_API || '',
    VITE_USER_GUIDE_URL: import.meta.env.VITE_USER_GUIDE_URL || '',
    VITE_DOWNLOAD_PLUGIN_URL: import.meta.env.VITE_DOWNLOAD_PLUGIN_URL || '',
    VITE_ENV: import.meta.env.VITE_ENV || '',
    VITE_APPINSIGHTS_INSTRUMENTATION_KEY: import.meta.env.VITE_APPINSIGHTS_INSTRUMENTATION_KEY || '',
    VITE_COOKIE_CONSENT_DATA_ATTRIBUTE: import.meta.env.VITE_COOKIE_CONSENT_DATA_ATTRIBUTE || '',
  }
}

export const runtimeConfig = getConfig()
